module.exports = __webpack_public_path__ + "media/images/icons/watchlist-d7bbdc9e36ce8eb46f19c2a72fbe6cd5.svg";